import FinanceAdapter from './base';

export default class Discrepancy extends FinanceAdapter {
  modelNamePlural = 'discrepancies';
}
